"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var next = _interopRequireWildcard(require("./"));

window.next = next;
(0, next["default"])()["catch"](console.error);